const StateMultiselectHook = {
  mounted() {
    let currentEl = this.el;
    // set the initial value of the select element to empty, to handle when
    // the user is loading previously-saved values.
    currentEl.value = "";

    this.el.addEventListener("input", (_e) => {
      // push an event to the live component with the value of the select element
      this.pushEventTo("#state-multiselect", "state_added", {
        state: currentEl.value,
      });

      // reset the value of the select element
      currentEl.value = "";
    });
  },
};

export default StateMultiselectHook;
